Object.defineProperty(exports,"__esModule",{value: true});
exports.default=window.GrimoireJS&&window.GrimoireJS.lib.fundamental?window.GrimoireJS.lib.fundamental.Util.HashCalculator:undefined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/grimoirejs-fundamental/ref/Util/HashCalculator.js
// module id = 35
// module chunks = 0